module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._t("header", [_c('h4', [_vm._v(_vm._s(_vm.src.substring(0, 100)) + "...")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "btn btn-default btn-lg",
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "15px",
      "border": "0 none"
    },
    attrs: {
      "type": "link",
      "title": "Fenster schließen"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove",
    attrs: {
      "aria-hidden": "true"
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('form', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "id": _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel')
      },
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('iframe', {
    staticStyle: {
      "height": "80vh"
    },
    attrs: {
      "id": "",
      "name": "",
      "src": _vm.src,
      "width": "100%",
      "height": "800px",
      "marginheight": "0",
      "marginwidth": "0",
      "frameborder": "0",
      "scrolling": "Yes"
    }
  })])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c8695ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ExternSite.vue
// module id = 283
// module chunks = 0